import React from "react";

const RefundPolicy = () => {
  return (
    <div className="max-w-4xl mx-auto py-16 px-6 text-gray-700 leading-relaxed">
      <h1 className="text-3xl font-bold mb-6 text-black">Refund Policy</h1>

      <p className="mb-6">
        Last updated: <strong>31 jan 2026</strong>
      </p>

      <p className="mb-6">
        This Refund Policy outlines the terms and conditions under which refunds
        are processed for orders placed with us. By making a payment, you agree
        to the refund terms described below.
      </p>

      <h2 className="text-xl font-semibold mt-8 mb-3 text-black">
        1. Order Non-Delivery
      </h2>
      <p>
        If payment has been completed and the product is <strong>not delivered</strong>,
        the customer is eligible for a <strong>100% refund</strong> of the amount
        paid, including the product cost.
      </p>

      <h2 className="text-xl font-semibold mt-8 mb-3 text-black">
        2. Order in Transit
      </h2>
      <p>
        If the order has been dispatched and is <strong>in transit</strong>, and
        the customer requests a cancellation or refund:
      </p>
      <ul className="list-disc pl-6 space-y-2 mt-2">
        <li>The <strong>product cost</strong> will be refunded.</li>
        <li>
          <strong>Delivery or transportation charges are non-refundable.</strong>
        </li>
      </ul>

      <h2 className="text-xl font-semibold mt-8 mb-3 text-black">
        3. Product Delivered and Unloaded
      </h2>
      <p>
        Once the product has been <strong>delivered and unloaded</strong> from
        the delivery vehicle at the customer’s location, the order is considered
        fulfilled.
      </p>
      <p className="mt-2">
        If a refund is requested after delivery and unloading:
      </p>
      <ul className="list-disc pl-6 space-y-2 mt-2">
        <li>The <strong>product cost</strong> may be refunded after inspection.</li>
        <li>
          <strong>
            Two times (2×) the delivery or transportation cost will be deducted
          </strong>{" "}
          from the refundable amount to cover return logistics and handling.
        </li>
      </ul>

      <h2 className="text-xl font-semibold mt-8 mb-3 text-black">
        4. Refund Method & Timeline
      </h2>
      <p>
        Approved refunds will be processed to the original payment method used
        at the time of purchase via the same payment gateway.
      </p>
      <p className="mt-2">
        Refunds are typically completed within <strong>5–10 business days</strong>,
        subject to bank or payment provider processing times.
      </p>

      <h2 className="text-xl font-semibold mt-8 mb-3 text-black">
        5. Non-Refundable Situations
      </h2>
      <ul className="list-disc pl-6 space-y-2">
        <li>Incorrect delivery details provided by the customer</li>
        <li>Refusal to accept delivery without valid reason</li>
        <li>Force majeure events beyond our control</li>
      </ul>

      <h2 className="text-xl font-semibold mt-8 mb-3 text-black">
        6. Payment Gateway Compliance
      </h2>
      <p>
        All refunds are processed in accordance with applicable payment gateway
        policies and regulatory guidelines. We do not issue cash refunds under
        any circumstances.
      </p>

      <h2 className="text-xl font-semibold mt-8 mb-3 text-black">
        7. Policy Updates
      </h2>
      <p>
        We reserve the right to modify this Refund Policy at any time. Updates
        will be posted on this page with a revised date.
      </p>

      <h2 className="text-xl font-semibold mt-8 mb-3 text-black">
        8. Contact Us
      </h2>
      <p>
        For refund-related questions or requests, please contact us:
      </p>
      <p className="mt-2">
        <strong>Business Name:</strong> __________ <br />
        <strong>Phone:</strong> __________ <br />
        <strong>Email:</strong> __________
      </p>
    </div>
  );
};

export default RefundPolicy;
